<div class="threshold-help-popover">
  <section class="threshold-help-popover__body">
    <p class="threshold-help-popover__title">
      {{ 'stores.forms.steps.threshold.title' | translate }}
    </p>
    <p class="threshold-help-popover__description">
      {{ 'stores.forms.steps.threshold.description' | translate }}
    </p>
  </section>
</div>
